import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url,
  type = 'website',
  structuredData 
}) => {
  const siteUrl = 'https://kamalinstitute.co.in';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const imageUrl = image ? `${siteUrl}${image}` : `${siteUrl}/og-image.jpg`;
  const defaultTitle = 'Kamal Institute - Goldsmith & Silversmith Courses | Ajmer, Rajasthan';
  const defaultDescription = 'Master the art of goldsmithing and silversmithing through immersive hands-on training with industry experts. Join our fully residential program in Ajmer, Rajasthan.';
  const defaultKeywords = 'goldsmith course, silversmith course, jewellery making course, handmade jewellery training, jewellery institute India, Ajmer jewellery course, goldsmithing training, silversmithing training, jewellery certification, Kamal Institute';

  const pageTitle = title ? `${title} | Kamal Institute` : defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <meta name="author" content="Kamal Institute" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Kamal Institute" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Additional SEO */}
      <meta name="geo.region" content="IN-RJ" />
      <meta name="geo.placename" content="Ajmer" />
      <meta name="geo.position" content="26.4499;74.6399" />
      <meta name="ICBM" content="26.4499, 74.6399" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
